import { render } from "./UsuarioToGrupoComponent.vue?vue&type=template&id=2ec4797c"
import script from "./UsuarioToGrupoComponent.vue?vue&type=script&lang=js"
export * from "./UsuarioToGrupoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/mac2/Herd/mix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__